import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import * as angular from "angular";
import { EntityConfigService } from "../services/entity-config-service";
import { EntityService } from "../services/entity-service";


RLReportParamPickerV2.$inject = ["$timeout"];
export function RLReportParamPickerV2($timeout: ng.ITimeoutService) {
    var directive: ng.IDirective = {
        template: require("/assets/app/templates/report-param-picker-v2.html"),
        controller: RLReportParamPickerV2Controller,
        controllerAs: "rppVM",
        scope: {
            selectedParameter: "=rlReportParamPickerV2",
            modalOpen: "=",
            mode: "=?"
        },
        bindToController: {
            allowMultiple: "=?",
            selectedParameter: "=rlReportParamPickerV2",
            shouldSave: "=",
            shouldReset: "=",
            hasHierarchy: "=?",
            modalStyle: "=?",
            showAdvance: "=?",
            selectedRecIdTitlePairs: "=?"
        },
        require: "rlReportParamPickerV2",
        link: (scope: IRLReportParamPickerV2Scope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: RLReportParamPickerV2Controller) => { }
    };
    return directive;
}

interface IRLReportParamPickerV2Scope extends ng.IScope {
    selectedParameter: Models.IReportParameter;
    modalOpen: boolean;
    mode: string;
}

class RLReportParamPickerV2Controller {
    static $inject = ["$scope", "entityConfigService", "entityService", "$q", "$timeout"];
    paramRe: RegExp;
    xParamRe: RegExp;
    exactIndRe: string;
    mode: string;
    charTypeID: number;
    filterType: string;
    filterValue: number;
    selectType: string;
    loading: boolean;
    yesNoInd: string;
    dynamicParamRegex: RegExp;
    dynamicParamName: string;
    ccParamRe: RegExp;
    templates: Models.ICharacteristicTemplate[];
    selectedTemplates: Models.ICharacteristicTemplate[];
    statuses: Models.IEntityStatus[];
    selectedStatuses: Models.IEntityStatus[];
    lovs: Models.ICharacteristicMetaDataValue[];
    selectedLovs: Models.ICharacteristicMetaDataValue[];
    newTreeLovs: Models.ICharacteristicMetaDataValue[];
    newTreeCharValueGroups: Models.ICharacteristicValueGroup[];
    newTreeSelectedGroup: Models.ICharacteristicValueGroup;

    newSelectedTreeLovs: Models.ICharacteristicMetaDataValue[];
    newSelectedTreeLovIDs: number[];
    selectedIndicator: string;
    selectedRecIdTitlePairs: Models.IKeyValuePair<number, string>[];
    showColumns: string[];
    dynamiclovs: Models.IDynamicReportLOV[];
    dynamiclovsCount: number;
    dynamiclovsPage: number;
    dynamiclovsPageSize: number;
    dynamiclovsPageCount: number;
    dynamiclovsSearchTerm: string;
    selectedDynamicLovs: Models.IDynamicReportLOV[];
    canCreate: boolean;
    allowMultiple: boolean;
    isDisabled: boolean;
    showAdvance: boolean;
    searchFilterValue: string;

    //paramOutput: string;
    //paramDisplay: string;
    selectedParameter: Models.IReportParameter;

    hasHierarchy: boolean;  // output parameter -> to tell the parent controller if there is a tree/hierarchy or not

    shouldSave: boolean;
    shouldReset: boolean;
    templateIDs: string[];

    constructor(private $scope: IRLReportParamPickerV2Scope, private entityConfigService: EntityConfigService, private entityService: EntityService, private $q: ng.IQService, private $timeout: ng.ITimeoutService) {
        this.paramRe = /p_c(\d+)([txs])(\d+|\*)?([rsv])?(__.*)?/;
        this.xParamRe = /p_xx_(\d+)/;
        this.exactIndRe = "p_exact_ind";
        this.yesNoInd = "p_yesno_ind";
        this.dynamicParamRegex = /p_dd_(.+)?/;
        this.mode = "";
        this.charTypeID = 0;
        this.filterType = "";
        this.filterValue = 0;
        this.selectType = "";
        this.loading = false;
        this.templates = [];
        this.selectedTemplates = [];
        this.statuses = [];
        this.selectedStatuses = [];
        this.lovs = [];
        this.selectedLovs = [];
        this.selectedIndicator = "";
        this.selectedRecIdTitlePairs = [];
        this.dynamicParamName = "";
        this.dynamiclovs = [];
        this.dynamiclovsCount = 0;
        this.dynamiclovsPage = 1;
        this.dynamiclovsPageSize = 20;
        this.dynamiclovsPageCount = 1;
        this.dynamiclovsSearchTerm = "";
        this.ccParamRe = /p_cc_([d])(\d+|\*)?([p])(\d+|\*)?/;
        this.selectedDynamicLovs = [];
        this.showColumns = [];
        this.canCreate = false;
        this.isDisabled = false;
        this.newTreeLovs = [];
        this.newTreeCharValueGroups = [];
        this.newTreeSelectedGroup = null;
        this.newSelectedTreeLovs = [];
        this.newSelectedTreeLovIDs = [];
        this.templateIDs = [];
        this.searchFilterValue = "";

        $scope.$watch(() => this.mode, (newValue, oldValue) => {
            $scope.mode = this.mode;
        });

        $scope.$watch(() => this.shouldReset, (newValue, oldValue) => {
            if (newValue) {
                this.shouldReset = false;
                this.Reset();
            }
        });

        $scope.$watch(() => $scope.selectedParameter, (newValue, oldValue) => {
            if (newValue) {
                this.ParseParameter(newValue.parameterName);
                this.Setup();
                if (_.isEmpty(newValue.selectedParameterValue)) {
                    this.selectedTemplates = [];
                    this.selectedStatuses = [];
                    this.selectedLovs = [];
                    this.selectedRecIdTitlePairs = [];
                    this.selectedDynamicLovs = [];
                    this.newSelectedTreeLovs = [];
                    this.newSelectedTreeLovIDs = [];
                }
                else {
                    if (this.mode === "records") {
                        this.UpdateSelectedFromParamOutput();
                    }
                }
            }
        });


        // watch mode and chartype/filter/select for changes to re-establish UI
        //$scope.$watch(() => [this.mode, this.charTypeID,  this.selectType],
        //	(newValue, oldValue) => {
        //		if (newValue != oldValue) {
        //			this.Setup();
        //		}
        //	},
        //	true);

        $scope.$watch(() => this.dynamiclovsCount,
            (newValue) => {
                this.dynamiclovsPageCount = Math.ceil(newValue / this.dynamiclovsPageSize);
            }, true);


        // watch selected values to populate output variable
        $scope.$watch(() => [this.mode, this.selectedTemplates, this.selectedStatuses, this.selectedLovs, this.newSelectedTreeLovs, this.selectedRecIdTitlePairs, this.selectedIndicator, this.selectedDynamicLovs],
            (newValue, oldValue) => {
                if (newValue != oldValue) {
                    if (this.mode == "templates") {
                        $scope.selectedParameter.selectedParameterValue = _(this.selectedTemplates)
                            .map((t) => t.templateID)
                            .uniq()
                            .value()
                            .join(",");
                        $scope.selectedParameter.selectedParameterDisplay = _(this.selectedTemplates)
                            .map((t) => t.templateName)
                            .uniq()
                            .value()
                            .join(", ");
                    } else if (this.mode == "statuses") {
                        $scope.selectedParameter.selectedParameterValue = _(this.selectedStatuses)
                            .map((s) => s.stepID)
                            .uniq()
                            .value()
                            .join(",");
                        $scope.selectedParameter.selectedParameterDisplay = _(this.selectedStatuses)
                            .map((s) => s.stepName)
                            .uniq()
                            .value()
                            .join(", ");
                    } else if (this.mode == "lovs") {
                        this.UpdateLovsFromSelected();
                    } else if (this.mode == "records") {
                        $scope.selectedParameter.selectedParameterValue = _(this.selectedRecIdTitlePairs)
                            .map(doc => doc.key)
                            .uniq()
                            .value()
                            .join(",");
                        $scope.selectedParameter.selectedParameterDisplay = _(this.selectedRecIdTitlePairs)
                            .map(doc => doc.value)
                            .uniq()
                            .value()
                            .join(", ");
                    } else if (this.mode == "exactInd") {
                        $scope.selectedParameter.selectedParameterValue = this.selectedIndicator;
                        $scope.selectedParameter.selectedParameterDisplay = "";
                        if (this.selectedIndicator == "0") {
                            $scope.selectedParameter.selectedParameterDisplay = "Flexible";
                        } else if (this.selectedIndicator == "1") {
                            $scope.selectedParameter.selectedParameterDisplay = "Exact";
                        }
                    } else if (this.mode == "yesNoInd") {
                        $scope.selectedParameter.selectedParameterValue = this.selectedIndicator;
                        $scope.selectedParameter.selectedParameterDisplay = "";
                        if (this.selectedIndicator == "0") {
                            $scope.selectedParameter.selectedParameterDisplay = "Yes";
                        } else if (this.selectedIndicator == "1") {
                            $scope.selectedParameter.selectedParameterDisplay = "No";
                        }
                    } else if (this.mode == "dynamiclovs") {
                        $scope.selectedParameter.selectedParameterValue = _(this.selectedDynamicLovs)
                            .map((lov) => lov.recID)
                            .uniq()
                            .value()
                            .join(",");
                        $scope.selectedParameter.selectedParameterDisplay = _(this.selectedDynamicLovs)
                            .map((lov) => lov.col2)
                            .uniq()
                            .value()
                            .join(", ");
                    }
                }
                if (!this.$scope.modalOpen) {  // modal not open -> assuming that a value is being set by parent, and it needs the param display value to be set
                    this.Save();
                }
            }, true);

        $scope.$watch(() => this.dynamiclovsPage,
            (newValue) => {
                if (this.dynamicParamName != "") {
                    this.SearchDynamicLovs();
                }
            }, true);

    }

    $onInit() {
        if (this.showAdvance == null) {
            this.showAdvance = this.allowMultiple;
        }
    }

    keyPressHandeler(e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    UpdateLovsFromSelected() {

        if (this.newTreeLovs.length > 0) {
            this.$scope.selectedParameter.selectedParameterValue = _(this.newSelectedTreeLovs)
                .map((lov) => lov.characteristicValueID)
                .uniq()
                .value()
                .join(",");
            this.$scope.selectedParameter.selectedParameterDisplay = _(this.newSelectedTreeLovs)
                .map((lov) => lov.characteristicValueLabel)
                .uniq()
                .value()
                .join(", ");
        } else if (this.selectedLovs.length > 0) {
            this.$scope.selectedParameter.selectedParameterValue = _(this.selectedLovs)
                .map((lov) => lov.characteristicValueID)
                .uniq()
                .value()
                .join(",");
            this.$scope.selectedParameter.selectedParameterDisplay = _(this.selectedLovs)
                .map((lov) => lov.characteristicValueLabel)
                .uniq()
                .value()
                .join(", ");
        }

        return;
    }

    UpdateSelectedFromParamOutput() {

        if (this.mode === "lovs") {
            if (this.newTreeLovs.length > 0)
                this.UpdateSelectedTreeLovsFromParamOutput();
            else if (this.lovs.length > 0)
                this.UpdateSelectedLovsFromParamOutput();
        }
        else if (this.mode === "templates") {
            this.UpdateSelectedTemplatesFromParamOutput();
        }
        else if (this.mode === "records") {
            this.UpdateSelectedRecordsFromParamOutput();
        }
    }

    UpdateSelectedRecordsFromParamOutput() {
        this.SetupRecords();
    }

    UpdateSelectedLovsFromParamOutput() {

        var newSelectedLovs: Models.ICharacteristicMetaDataValue[] = [];

        if (!_.isEmpty(this.$scope.selectedParameter.selectedParameterValue)) {
            var defaultValues = this.$scope.selectedParameter.selectedParameterValue.split(",");
            _.forEach(defaultValues, (dv) => {
                if (_.any(this.lovs, l => l.characteristicValueID === _.parseInt(dv))) {
                    var selectedLov = _.find(this.lovs, l => l.characteristicValueID === _.parseInt(dv));
                    newSelectedLovs.push(selectedLov);
                }
            });
        }

        this.selectedLovs = newSelectedLovs;

        return;
    }

    UpdateSelectedTemplatesFromParamOutput() {

        var newSelectedTemplates: Models.ICharacteristicTemplate[] = [];

        if (!_.isEmpty(this.$scope.selectedParameter.selectedParameterValue)) {
            var defaultValues = this.$scope.selectedParameter.selectedParameterValue.split(",");
            _.forEach(defaultValues, (dv) => {
                if (_.any(this.templates, l => l.templateID == _.parseInt(dv))) {
                    var selectedTemplate = _.find(this.templates, l => l.templateID == _.parseInt(dv));
                    newSelectedTemplates.push(selectedTemplate);
                }
            });
            this.selectedTemplates = newSelectedTemplates;
        }

        return;
    }

    UpdateSelectedTreeLovsFromParamOutput() {

        var newSelectedTreeLovs: Models.ICharacteristicMetaDataValue[] = [];
        var newSelectedTreeLovIDs: number[] = [];

        if (!_.isEmpty(this.$scope.selectedParameter.selectedParameterValue)) {
            var defaultValues = this.$scope.selectedParameter.selectedParameterValue.split(",");
            _.forEach(defaultValues, (dv) => {
                newSelectedTreeLovIDs.push(_.parseInt(dv));
                _.foreachGraph(this.newTreeLovs, (tlov) => tlov.childValues, (tlov) => {
                    if (tlov.characteristicValueID == _.parseInt(dv)) {
                        newSelectedTreeLovs.push(tlov);
                    }
                });
            });
        }
        this.$timeout(() => {
            this.newSelectedTreeLovs = newSelectedTreeLovs;
            this.newSelectedTreeLovIDs = newSelectedTreeLovIDs;
            this.$scope.$broadcast(Consts.Events.TreeListShowSelected);
        });
    }

    Reset() {
        this.UpdateSelectedFromParamOutput();
        return;
    }

    Save() {
        this.shouldSave = true;
    }

    ParseParameter(parameterKey: string) {
        this.mode = "";
        this.charTypeID = 0;
        this.filterType = "";
        this.filterValue = 0;
        this.selectType = "";
        this.dynamicParamName = "";
        this.searchFilterValue = "";

        if (this.paramRe.test(parameterKey)) {
            var match = this.paramRe.exec(parameterKey);

            if (match[1] != null) {
                this.charTypeID = _.parseInt(match[1]);
            }

            if (match[2] != null) {
                this.filterType = match[2];
            }

            if (match[3] != null) {
                this.filterValue = _.parseInt(match[3]);
                if (match[3] == "*") {
                    this.filterValue = -1;
                }
            }

            if (match[4] != null) {
                this.selectType = match[4];
            }

            if (this.selectType == "r") {
                this.mode = "records";

                var temp = _.last(match) || "";

                this.showColumns = _(temp.split("__"))
                    .filter((v) => !_.isEmpty(v))
                    .valueOf();

                if (this.filterType != "t") {
                    throw "invalid filtertype for records";
                }
            } else if (this.selectType == "s") {
                this.mode = "statuses";

                if (this.filterType != "t") {
                    throw "invalid filtertype for statuses";
                }
            } else if (this.selectType == "v") {
                this.mode = "lovs";

                var temp = _.last(match) || "";
                if (!_.isEmpty(temp)) {
                    this.templateIDs = _(temp.split("__"))
                        .filter((v) => !_.isEmpty(v))
                        .valueOf();
                }
                else {
                    this.templateIDs = [];
                }

                if (this.filterType != "x" && this.filterType != "s") {
                    throw "invalid filtertype for lovs";
                }
            } else if (this.selectType == "" && this.filterType == "t") {
                this.mode = "templates";
            }
        } else if (this.xParamRe.test(parameterKey)) {
            var match2 = this.xParamRe.exec(parameterKey);
            this.mode = "lovs";
            this.filterType = "xx";
            this.filterValue = _.parseInt(match2[1]);
        } else if (parameterKey == this.exactIndRe) {
            this.mode = "exactInd";
        } else if (parameterKey == this.yesNoInd) {
            this.mode = "yesNoInd";
        }
        else if (this.dynamicParamRegex.test(parameterKey)) {
            var match3 = this.dynamicParamRegex.exec(parameterKey);
            this.dynamicParamName = match3[1];
            this.mode = "dynamiclovs";
        }
        else if (this.ccParamRe.test(parameterKey)) {
            var match4 = this.ccParamRe.exec(parameterKey);
            this.mode = "lovs";
            this.filterType = "xx";
            this.filterValue = _.parseInt(match4[4]);
        }
    }

    Setup() {
        this.selectedTemplates = [];
        this.selectedStatuses = [];
        this.selectedLovs = [];
        this.selectedRecIdTitlePairs = [];
        this.selectedDynamicLovs = [];

        switch (this.mode) {
            case "templates":
                this.SetupTemplates();
                break;
            case "records":
                this.SetupRecords();
                break;
            case "statuses":
                this.SetupStatuses();
                break;
            case "lovs":
                this.SetupLovs();
                break;
            case "exactInd":
                this.SetupExactInd();
                break;
            case "yesNoInd":
                this.SetupYesNoInd();
                break;
            case "dynamiclovs":
                this.SetupDynamicLovs();
                break;
        }
    }

    SetupTemplates() {
        this.loading = true;
        this.entityConfigService.getCharacteristicTemplates(this.charTypeID)
            .then((results) => {
                this.templates = results;
                this.UpdateSelectedTemplatesFromParamOutput();
            })
            .finally(() => {
                this.loading = false;
            });
    }

    SetupDynamicLovs() {
        this.loading = true;
        this.SearchDynamicLovs()
            .finally(() => {
                this.loading = false;
            });
    }

    SetupExactInd() {
        angular.noop();
    }

    SetupYesNoInd() {
        angular.noop();
    }

    SetupRecords() {
        if (!_.isEmpty(this.$scope.selectedParameter.selectedParameterValue)) {
            this.loading = true;
            var splits = this.$scope.selectedParameter.selectedParameterValue.split(",");
            var paramValueLength = splits.length;

            var request: Models.ISearchResultByRecordIDsRequest = {
                charTypeID: this.charTypeID,
                recordIDs: this.$scope.selectedParameter.selectedParameterValue,
                rowCount: paramValueLength
            }

            this.entityService.getRecordDocumentsForRecordIDs(request)
                .then((result) => {
                    var newSelectedRecIdTitlePairs: Models.IKeyValuePair<number, string>[] = [];
                    _.forEach(result.documents, (recordDocument) => {
                        var selectedRecIDTitlePair: Models.IKeyValuePair<number, string> = {
                            key: recordDocument.recordID,
                            value: recordDocument.title
                        };
                        newSelectedRecIdTitlePairs.push(selectedRecIDTitlePair);
                    });
                    this.selectedRecIdTitlePairs = newSelectedRecIdTitlePairs;
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }

    SetupStatuses() {
        this.loading = true;
        this.entityConfigService.getTemplateStatuses(this.charTypeID, this.filterValue)
            .then((results) => {
                this.statuses = results;
                if (!_.isEmpty(this.$scope.selectedParameter.selectedParameterValue)) {
                    var defaultValues = this.$scope.selectedParameter.selectedParameterValue.split(",");
                    _.forEach(defaultValues, (dv) => {
                        if (_.any(this.statuses, l => l.stepID == _.parseInt(dv))) {
                            var selectedStatus = _.find(this.statuses, l => l.stepID == _.parseInt(dv));
                            this.selectedStatuses.push(selectedStatus);
                        }
                    });
                }
            })
            .finally(() => {
                this.loading = false;
            });
    }

    SetupLovs() {
        this.loading = true;
        var charID = -1;
        var systemIndicator = -1;
        this.hasHierarchy = false;
        this.newTreeLovs = [];
        this.newTreeCharValueGroups = [];
        // for special param types
        if (this.filterType == "xx") {
            this.entityConfigService.getReportParameterValueList(this.filterValue)
                .then((result) => {
                    this.lovs = result;
                    this.UpdateSelectedLovsFromParamOutput();
                })
                .finally(() => {
                    this.loading = false;
                });
        }
        else {
            if (this.filterType == "x") {
                charID = this.filterValue;
            } else if (this.filterType == "s") {
                systemIndicator = this.filterValue;
            }

            if (this.charTypeID == Consts.CharTypeIDs.right) {
                var charValueSource: Models.ICharacteristicValueSource;
                if (this.templateIDs.length > 0) {
                    var templateID = _.parseInt(this.templateIDs[0]);
                    this.entityConfigService.getCharacteristicTemplateMetaDataCollection(this.charTypeID, templateID)
                        .then((templateMetaDataResult) => {
                            this.lovs = [];
                            var charMetaData = _.find(templateMetaDataResult, tmd => tmd.characteristicID == charID);
                            this.SetUpTreeLovs(charMetaData.charValueSourceID, charMetaData.charValueSetID);
                            this.hasHierarchy = true;
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
                else {
                    this.entityConfigService.getCharacteristic(this.charTypeID, charID)
                        .then((result) => {
                            var charMedata = result;
                            this.lovs = [];
                            var hasHierarchyLOVSource: boolean = false;
                            var charValueSourceListResult: Models.ICharacteristicValueSource[] = [];
                            this.entityConfigService.getCharacteristicValueSourceList(charMedata.charValueSetID)
                                .then((result2) => {
                                    charValueSourceListResult = result2;
                                    if (charValueSourceListResult.length > 1) {
                                        var promises = [];
                                        _.forEach(charValueSourceListResult, r => {
                                            promises.push(this.entityService.getCharLovMetaData(r.charValueSourceID, r.charValueSetID)
                                                .then((rresult) => {
                                                    if (!hasHierarchyLOVSource) {
                                                        if (rresult.listOfValues[0].childValues.length > 0) {
                                                            charValueSource = r;
                                                            hasHierarchyLOVSource = true;
                                                            this.hasHierarchy = true;
                                                        }
                                                    }
                                                }));
                                        });
                                        return this.$q.all(promises);
                                    }
                                })
                                .finally(() => {
                                    if (!hasHierarchyLOVSource) {
                                        charValueSource = charValueSourceListResult[0];
                                    }
                                    this.SetUpTreeLovs(charValueSource.charValueSourceID, charValueSource.charValueSetID);
                                });
                        }).finally(() => {
                            this.loading = false;
                        });
                }

            }
            else {
                if (this.templateIDs.length > 0) {
                    var templateID = _.parseInt(this.templateIDs[0]);
                    this.entityConfigService.getCharacteristicTemplateMetaDataCollection(this.charTypeID, templateID)
                        .then((templateMetaDataResult) => {
                            this.lovs = [];
                            var charMetaData = _.find(templateMetaDataResult, tmd => tmd.characteristicID == charID);
                            this.SetUpTreeLovs(charMetaData.charValueSourceID, charMetaData.charValueSetID);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
                else {
                    this.entityConfigService.getLovList(this.charTypeID, charID, systemIndicator)
                        .then((result) => {
         
                            if (_(result).any(lov => lov.childValues.length > 0)) {

                            }
                            else {
                                this.lovs = result;
                                this.newTreeLovs = [];
                                if (!_.isEmpty(this.$scope.selectedParameter.selectedParameterValue)) {
                                    var defaultValues = this.$scope.selectedParameter.selectedParameterValue.split(",");
                                    _.forEach(defaultValues, (dv) => {
                                        if (_.any(this.lovs, l => l.characteristicValueID == _.parseInt(dv))) {
                                            var selectedLov = _.find(this.lovs, l => l.characteristicValueID == _.parseInt(dv));
                                            this.selectedLovs.push(selectedLov);
                                        }
                                    });
                                }
                            }
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            }
        }
    }

    SetUpTreeLovs(charValueSourceID: string, charValueSetID: string) {
        this.entityService.getCharLovMetaData(charValueSourceID, charValueSetID)
            .then((result3) => {
                this.newTreeLovs = result3.listOfValues;

                if (this.allowMultiple) {
                    this.newTreeCharValueGroups = result3.charValueGroups;
                    this.UpdateSelectedTreeLovsFromParamOutput();
                }
                else {
                    var newFlattenLovs: Models.ICharacteristicMetaDataValue[] = [];
                    _.foreachGraph(this.newTreeLovs, lov => lov.childValues, (lov) => {
                        newFlattenLovs.push(lov);
                    });
                    this.lovs = newFlattenLovs;
                    this.newTreeLovs = [];
                    this.UpdateSelectedLovsFromParamOutput();
                }
            });
    }

    LovGroupChanged(group: Models.ICharacteristicValueGroup) {
        var newValueIDs = [];
        if (group != null) {
            newValueIDs = group.charValueAssociations.map(cva => cva.charValueID);
        }
        while (this.newSelectedTreeLovIDs.pop()) {

        }
        Array.prototype.splice.apply(this.newSelectedTreeLovIDs, [0, 0].concat(newValueIDs));
        this.$scope.$broadcast(Consts.Events.TreeListShowSelected);
    }

    clearFilter() {
        this.searchFilterValue = "";
    }

    SelectAll() {
        this.selectedLovs = _.cloneDeep(this.lovs);
    }

    SelectNone() {
        this.selectedLovs = [];
    }

    SelectAllTemplates() {
        this.selectedTemplates = _.cloneDeep(this.templates);
    }

    SelectNoneTemplates() {
        this.selectedTemplates = [];
    }

    SelectAllStatusValues() {
        this.selectedStatuses = _.cloneDeep(this.statuses);
    }

    DeselectAllStatusValues() {
        this.selectedStatuses = [];
    }

    SelectAllDynamicLovs() {
        this.selectedDynamicLovs = _.cloneDeep(this.dynamiclovs);
    }

    SelectNoneDynamicLovs() {
        this.selectedDynamicLovs = [];
    }

    SearchDynamicLovs() {
        var pagedParamName = this.dynamicParamName.replace("p_1", "p_" + this.dynamiclovsPage);
        if (this.dynamiclovsSearchTerm != "") {
            pagedParamName = pagedParamName.replace("s_0", "s_%" + this.dynamiclovsSearchTerm.trim() + "%");
        }
        return this.entityConfigService.getReportDynamicParameterValueList(pagedParamName)
            .then((results) => {
                this.dynamiclovs = results.params;
                this.dynamiclovsCount = results.totalRecords;
            });
    }

    PreventSubmit($event: JQueryEventObject) {
        if ($event.keyCode == 13) {
            this.SearchDynamicLovs();
            $event.preventDefault();
        }
    }

    SelectLov(lov: Models.ICharacteristicMetaDataValue) {
        this.selectedLovs = [];
        this.selectedLovs.push(lov);
        if (!this.allowMultiple) {  // then automatically save (the modal will be closed automatically)
            this.UpdateLovsFromSelected();
            this.Save();
        }
    }

    SelectDynamicLov(dynamicLov: Models.IDynamicReportLOV) {
        this.selectedDynamicLovs = [];
        this.selectedDynamicLovs.push(dynamicLov);
    }
}
